import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9bd93fda"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "admin-home-page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page-title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "page-title-text-area" }, [
    /*#__PURE__*/_createElementVNode("h1", null, "Admin")
  ])
], -1))
const _hoisted_3 = { class: "stats" }
const _hoisted_4 = { class: "stat-number" }
const _hoisted_5 = { class: "stat-label" }
const _hoisted_6 = { class: "dashboard" }
const _hoisted_7 = { class: "card-title" }
const _hoisted_8 = { class: "card-text" }

import { computed, onMounted, ref, Ref } from 'vue'
import { usePageTitle } from '@/util/AppUtil'
import { useUserStore } from '@/gp/UserStore'
import { useSyncStore } from '@/rd/SyncStore'
import LoadingIndicator from '@/util/LoadingIndicator.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'AdminHomePage',
  setup(__props) {

usePageTitle('Admin')

const userStore = useUserStore()
const syncStore = useSyncStore()

// undefined while loading, null if the metric isn't available for this user's privileges
const totalUsersRef = ref<number | null>()
const totalSyncsRef = ref<number | null>()

const stats = computed(() => [
  { label: 'Total users', value: totalUsersRef.value },
  { label: 'Total syncs', value: totalSyncsRef.value },
])

const cards = [
  { to: '/admin/users', title: 'Manage users', text: 'Search users and review sync, sharing, and plan activity.' },
  { to: '/admin/identities', title: 'Manage identities', text: 'Review and manage sign-in identities.' },
]

onMounted(() => {
  loadStat(() => userStore.getUserCountAsync(), totalUsersRef)
  loadStat(() => syncStore.getSyncCountAsync(), totalSyncsRef)
})

async function loadStat(fetch: () => Promise<number>, target: Ref<number | null | undefined>) {
  try {
    target.value = await fetch()
  }
  catch {
    target.value = null
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stats.value, (stat) => {
        return (_openBlock(), _createElementBlock("div", {
          key: stat.label,
          class: "stat-card"
        }, [
          _createElementVNode("div", _hoisted_4, [
            (stat.value === undefined)
              ? (_openBlock(), _createBlock(LoadingIndicator, { key: 0 }))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(stat.value?.toLocaleString() ?? '—'), 1)
                ], 64))
          ]),
          _createElementVNode("div", _hoisted_5, _toDisplayString(stat.label), 1)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(cards, (card) => {
        return _createVNode(_component_router_link, {
          key: card.to,
          class: "card",
          to: card.to
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, _toDisplayString(card.title), 1),
            _createElementVNode("div", _hoisted_8, _toDisplayString(card.text), 1)
          ]),
          _: 2
        }, 1032, ["to"])
      }), 64))
    ])
  ]))
}
}

})